export default __webpack_public_path__ + "static/help_06_02-3-9fbde717491c4b334e537d283f90b1db.png";